// extracted by mini-css-extract-plugin
module.exports = {"root":"Switch_root__2sExe","error":"Switch_error__1a7De","warning":"Switch_warning__3c-LL"};